document.addEventListener('DOMContentLoaded', function() {
  const featuredElements = document.querySelectorAll('.bg-featured');
  
  // Create an IntersectionObserver
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      // Target the .bg-product-info img and .bg-wrapper inside the specific .bg-featured in view
      const productInfoImg = entry.target.querySelector('.bg-product-info img');
      const bgWrapper = entry.target.querySelector('.bg-wrapper');
      
      if (entry.isIntersecting) {
        // Apply rotation to the image
        if (productInfoImg) {
          productInfoImg.style.transition = 'transform 1s ease';
          productInfoImg.style.transform = 'rotate(15deg)';
        }
        
        // Apply scale to the .bg-wrapper
        if (bgWrapper) {
          bgWrapper.style.transition = 'transform 1s ease';
          bgWrapper.style.transform = 'scale(1.05)';
        }
      } else {
        // Reset the image rotation
        if (productInfoImg) {
          productInfoImg.style.transform = 'rotate(-15deg)';
        }
        
        // Reset the .bg-wrapper scale
        if (bgWrapper) {
          bgWrapper.style.transform = 'scale(1)';
        }
      }
    });
  }, {
    threshold: 0.2 // Trigger when 20% of the element is in view
  });

  // Observe each .bg-featured element
  featuredElements.forEach((element) => {
    observer.observe(element);
  });
});


document.addEventListener('DOMContentLoaded', function() {
  const bgWrappers = document.querySelectorAll('.bg-wrapper');
  const container = document.querySelector('.bg-featured-container'); // Adjust this selector to the parent container
  
  let isScrolling;
  
  container.addEventListener('scroll', function() {
    window.clearTimeout(isScrolling);
    
    isScrolling = setTimeout(function() {
      snapScroll();
    }, 100); // Adjust the delay for the snapping effect
  });

  function snapScroll() {
    const scrollPosition = container.scrollTop;
    let closestElement = null;
    let minDistance = Number.MAX_VALUE;
    
    bgWrappers.forEach(wrapper => {
      const offsetTop = wrapper.offsetTop;
      const distance = Math.abs(scrollPosition - offsetTop);
      
      if (distance < minDistance) {
        minDistance = distance;
        closestElement = wrapper;
      }
    });
    
    if (closestElement) {
      container.scrollTo({
        top: closestElement.offsetTop,
        behavior: 'smooth'
      });
    }
  }
});

document.addEventListener('DOMContentLoaded', function() {
  // Select the existing popup-content and popup-overlay
  const popupContent = document.querySelector('.popup-contentt');
  const popupOverlay = document.querySelector('#popup-modal');

  if (popupContent && popupOverlay) {
    // Remove them from their current parent and append them to the body
    document.body.appendChild(popupOverlay);
    popupOverlay.appendChild(popupContent);

    // Add the 'show' class when popup is appended to the body
    popupOverlay.classList.add('show');

    // Ensure popup is hidden by default
    popupOverlay.style.display = 'none';

    // Function to show the popup
    function showPopup() {
      popupOverlay.style.display = 'flex'; // Use flex to center content
    }

    // Function to hide the popup
    function hidePopup() {
      popupOverlay.style.display = 'none';
    }

    // Add event listener for close button
    document.querySelector('.close-btn').addEventListener('click', hidePopup);

    // Show popup on clicking a button (replace with your actual trigger event)
    document.querySelector('.show-popup-btn').addEventListener('click', showPopup);

    // Hide popup when clicking outside the popup content area
    popupOverlay.addEventListener('click', function(event) {
      if (event.target === popupOverlay) {
        hidePopup();
      }
    });
  }
});


// document.querySelector('.ecomsend__Modal__CloseText').addEventListener('click', function(event) {
//     event.preventDefault(); // Prevent default popup close action
//     event.stopPropagation(); // Stop event from bubbling up if necessary

//     const textToCopy = this.innerText; // Get the inner content of the element
//     navigator.clipboard.writeText(textToCopy).then(() => {
//         console.log('Text copied to clipboard:', textToCopy);
        
//         // Close the popup manually after copying the text, if needed
//         // You can call the original close popup function here
//         // closePopup(); // Uncomment if there's a function to close the popup

//     }).catch(err => {
//         console.error('Failed to copy text:', err);
//     });
// });
const body = document.body;
const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, null, false);

let node;
while (node = walker.nextNode()) {
    if (node.nodeValue.includes('tag -->')) {
        const span = document.createElement('span');
        span.style.display = 'none';
        node.parentNode.replaceChild(span, node); // Hide the text node
    }
}

$(document).ready(function() {
  var maxHeight = 0;

  // Find the max height
  $('.owl-item').each(function() {
    var thisHeight = $(this).height();
    if (thisHeight > maxHeight) {
      maxHeight = thisHeight;
    }
  });

  // Set all items to the max height
  $('.owl-item').each(function() {
    $(this).css('height', maxHeight + 'px');
  });
});

// document.addEventListener('DOMContentLoaded', function () {
//     var videoContainer = document.querySelector('.reelUp_carousel_wrapper'); // Your container class
//     if (!videoContainer) return; // Exit if the container isn't found

//     var scrollSpeed = 0.8; // Speed of auto-scroll (adjust as needed)
    
//     function autoScroll() {
//         videoContainer.scrollLeft += scrollSpeed; // Move the scroll position forward

//         // If scrolled to the end, reset smoothly to the start
//         if (videoContainer.scrollLeft >= videoContainer.scrollWidth - videoContainer.clientWidth) {
//             videoContainer.scrollLeft = 0;
//         }

//         requestAnimationFrame(autoScroll);
//     }

//     autoScroll(); // Start scrolling immediately
// });

// document.addEventListener('DOMContentLoaded', function () {
//     var videoContainer = document.querySelector('.reelUp_carousel_wrapper'); // Your container class
//     if (!videoContainer) return; // Exit if the container isn't found

//     var videoItems = Array.from(videoContainer.children); // Convert HTMLCollection to an array
//     var scrollSpeed = 0.8; // Speed of auto-scroll (adjust as needed)
//     var scrollAmount = 0;
//     var videoWidth = videoItems[0].offsetWidth; // Width of a single video/item
//     var totalWidth = videoWidth * videoItems.length; // Total width of all items

//     // Clone video items to create the infinite loop
//     // function cloneItems() {
//     //     videoItems.forEach(item => {
//     //         var clonedItem = item.cloneNode(true);
//     //         videoContainer.appendChild(clonedItem);
//     //     });
//     // }

//     // cloneItems(); // Clone items immediately for faster execution

//     // Function to handle smooth auto-scrolling with an infinite loop
//     function autoScroll() {
//         scrollAmount += scrollSpeed; // Increase scroll amount

//         // If scroll reaches the end of original set, reset it smoothly
//         if (scrollAmount >= totalWidth) {
//             scrollAmount = 0;
//         }

//         videoContainer.scrollLeft = scrollAmount;

//         requestAnimationFrame(autoScroll);
//     }

//     autoScroll(); // Start scrolling immediately
// });


document.addEventListener('DOMContentLoaded', function () {
    var videoContainer = document.querySelector('.reelUp_carousel_wrapper'); // Your container class
    if (!videoContainer) return; // Exit if the container isn't found

    var scrollSpeed = 1; // Adjust speed for smooth scroll

    function autoScroll() {
        videoContainer.scrollLeft += scrollSpeed; // Move scroll forward

        // If the first video fully scrolls out of view, move it to the end
        if (videoContainer.scrollLeft >= videoContainer.scrollWidth - videoContainer.clientWidth) {
            videoContainer.appendChild(videoContainer.firstElementChild);
            videoContainer.scrollLeft -= videoContainer.firstElementChild.offsetWidth; // Adjust scroll position
        }

        requestAnimationFrame(autoScroll);
    }

    autoScroll(); // Start scrolling immediately
});

const target = document.querySelector('slider-component.slider-mobile-gutter.slider-component-full-width.scroll-trigger.animate--slide-in');
const imgs = target.querySelectorAll('ul img');

// Customize start and end (0 = bottom of viewport, 1 = top of viewport)
const startRatio = 0.8;  // animation starts when element top hits 50% of viewport
const endRatio = 0;      // animation ends when element top hits top of viewport

function handleScroll() {
  const rect = target.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;

  const startPx = windowHeight * startRatio;
  const endPx = windowHeight * endRatio;

  const distance = startPx - endPx;
  const current = startPx - rect.top;

  const progress = current / distance;
  const clamped = Math.max(0, Math.min(progress, 1));

  const rotate = clamped * 25;       // 0 to 20deg
  const scale = 1 + clamped * 0.4;   // 1 to 1.3

  imgs.forEach(img => {
    img.style.transform = `rotateZ(${rotate}deg) scale(${scale})`;
  });
}

window.addEventListener('scroll', handleScroll);
window.addEventListener('resize', handleScroll);
handleScroll(); // Initial run
